// External API Teams Phone Solutions

import { PRODUCT_CODES } from '../../helpers/Constants'
import {
  externalDIRECTROUTINGDownload,
  externalDIRECTROUTINGDownloadExcel,
  externalDIRECTROUTINGFetch,
  externalDIRECTROUTINGStore,
  externalDIRECTROUTINGUpdate,
  externalGENRICFUNCTIONALITYROUTINGStore,
  externalGENRICFUNCTIONALITYROUTINGFetch,
  externalGENRICFUNCTIONALITYROUTINGPatch,
  externalGENRICFUNCTIONALITYROUTINGDestroy,
  externalGENRICFUNCTIONALITYROUTINGUpdate,
  externalDIRECTROUTINGDestroy,
  externalDIRECTROUTINGCreateInstance,
  externalDIRECTROUTINGBaseGet,
  externalGENRICFUNCTIONALITYROUTINGFetchSIP,
  externalHttpGENERICFUNCTIONALITYCreateInstance,
  externalHttpGENERICFUNCTIONALITYUpdate,
  externalGENRICFUNCTIONALITYROUTINGDelete,
  externalDIRECTROUTINGBaseGetAPI,
  externalDIRECTROUTINGBaseDeleteAPI,
  externalDIRECTROUTINGBaseFetchAPI,
  externalDIRECTROUTINGBaseEditAPI,
  externalCoreViewBaseWebPortalGetAPI,
  externalCoreViewBaseWebPortalAPI,
} from '../utils/httpUtil'

export const orderingServiceRateCenterByState = (params, customerId) =>
  externalGENRICFUNCTIONALITYROUTINGFetch(
    `ratecenter`,
    params,
    customerId,
    PRODUCT_CODES.directRouting
  )
export const orderingServiceDIDAvailables = (params, customerId, productCode) =>
  externalGENRICFUNCTIONALITYROUTINGFetch(
    `DidNumber/available/dids`,
    params,
    customerId,
    productCode
  )
export const orderingServiceDIDNumberGet = (params, customerId) =>
  externalGENRICFUNCTIONALITYROUTINGFetch(
    `DidNumber`,
    params,
    customerId,
    PRODUCT_CODES.directRouting
  )

export const syncOrderingServiceDIDNumberGet = (params, customerId, productCode) =>
  externalGENRICFUNCTIONALITYROUTINGFetch(
    `DidNumber/SyncsNumberFeatureAsync`,
    params,
    customerId,
    productCode
  )
export const syncOrderingSIPServiceDIDNumberGet = (params, customerId, sipAddressId) =>
  externalGENRICFUNCTIONALITYROUTINGFetchSIP(
    `DidNumber/SyncsNumberFeatureAsync?sipAddressId=${sipAddressId}`,
    params,
    customerId
  )
export const orderingServiceTollFreesAvailables = (params, customerId) =>
  externalGENRICFUNCTIONALITYROUTINGFetch(
    `DidNumber/available/tollfrees`,
    params,
    customerId,
    PRODUCT_CODES.directRouting
  )
export const orderingServiceDIRECTROUTINGDIDFeaturesGet = (
  params,
  customerId
) =>
  externalGENRICFUNCTIONALITYROUTINGFetch(
    `DidNumber/features`,
    params,
    customerId,
    PRODUCT_CODES.directRouting
  )
export const orderingServiceDIRECTROUTINGDIDNumberPatch = (
  body,
  number,
  customerId
) =>
  externalGENRICFUNCTIONALITYROUTINGPatch(
    `DidNumber/did?Number=${number}`,
    body,
    customerId,
    PRODUCT_CODES.directRouting
  )
export const orderingServiceDIRECTROUTINGTollFreeNumberPatch = (
  body,
  number,
  customerId
) =>
  externalGENRICFUNCTIONALITYROUTINGPatch(
    `DidNumber/tollfree?Number=${number}`,
    body,
    customerId,
    PRODUCT_CODES.directRouting
  )

export const orderingServiceDIRECTROUTINGCallForwardBackupRemove = (
  body,
  number,
  customerId
) =>
  externalGENRICFUNCTIONALITYROUTINGPatch(
    `DidNumber/RemoveCallForwardingOrBackUp?Number=${number}`,
    body,
    customerId,
    PRODUCT_CODES.directRouting
  )

export const orderingServiceE911OverrideGet = (params, customerId) =>
  externalGENRICFUNCTIONALITYROUTINGFetch(
    `DidNumber/e911override`,
    params,
    customerId,
    PRODUCT_CODES.directRouting
  )

export const orderingServiceDIRECTROUTINGOrdersGet = (orderId, customerId) =>
  externalDIRECTROUTINGFetch(`order?Id=${orderId}`, '', customerId)

export const orderingServiceDIRECTROUTINGFeaturesGet = (params, customerId) =>
  externalDIRECTROUTINGFetch(`order/features`, params, customerId)

export const orderingServiceDIRECTROUTINGSummaryGet = (params, customerId) =>
  externalDIRECTROUTINGFetch(`order/summary`, params, customerId)

export const orderingServiceDIRECTROUTINGNumberAssignmentGet = (
  params,
  customerId
) =>
  externalDIRECTROUTINGFetch(`NumberAssignment/teamsUsers`, params, customerId)

export const updateNumberAssignmentsWithTeamsUsers = (
  params,
  customerId
) =>
  externalDIRECTROUTINGFetch(`NumberAssignment/latestNumberAssignmentInformation`, params, customerId)


export const editE911AddressToDB = (
  params,
  customerId,
  productCode
) =>
  externalHttpGENERICFUNCTIONALITYUpdate(`StaticE911`, params, customerId, productCode)

export const saveE911AddressToDB = (
  params,
  customerId,
  productCode
) =>
  externalHttpGENERICFUNCTIONALITYCreateInstance(`StaticE911`, params, customerId, productCode)

export const removeE911Address = (customerId, data, productCode) =>
  externalDIRECTROUTINGDestroy(
    `StaticE911/DisableStataiceE911Address/${data.ApE911AddressId}`,
    customerId,
    { CustomerId: customerId, AddressId: data.ApE911AddressId, productCode: productCode }
  )

export const getStaticE911AddressFromFromDb = (
  params,
  customerId,
  productCode
) =>
  externalGENRICFUNCTIONALITYROUTINGFetch(`StaticE911/GetStaticE911AddressFromDB`, params, customerId, productCode)


export const enabledE911AddressForNumber = (
  params,
  selectedAddressId,
  customerId,
  productCode
) =>
  externalGENRICFUNCTIONALITYROUTINGStore(
    `StaticE911/EnableE911NumberToAddress?productCode=${productCode}&CustomerId=${customerId}`,
    customerId,
    productCode,
    params
  )

export const disabledE911AddressForNumber = (
  params,
  selectedAddressId,
  customerId,
  productCode

) =>
  externalGENRICFUNCTIONALITYROUTINGDelete(
    `StaticE911/${params.Number}`,
    customerId,
    {
      CustomerId: customerId,
      productCode,
      number: params.Number
    },
    params
  )

export const getAssignE911AddressByNumber = (
  params,
  customerId,
  number,
  productCode
) =>
  externalDIRECTROUTINGBaseGet(`E911/GETE911NumberFromAddress?numbers=${number}`, params, customerId, productCode)
export const getAssignE911AddressByCompany = (
  params,
  customerId,
  productCode
) =>
  externalDIRECTROUTINGBaseGet(`E911/GETE911NumberFromAddress`, params, customerId, productCode)



export const orderingServiceDIRECTROUTINGNumberAssignmentGetFromDb = (
  params,
  customerId
) =>
  externalDIRECTROUTINGFetch(`NumberAssignment/teamsusersfromdb`, params, customerId)

export const teamSyncForCompany = (
  params,
  customerId
) =>
  externalDIRECTROUTINGFetch(`NumberAssignment/teamssyncforcompany`, params, customerId)


// export const teamSyncForCompany = (
//   params,
//   customerId
// ) =>
//   externalDIRECTROUTINGBaseFetchAPI(`NumberAssignment/teamssyncforcompany`, params, customerId)


export const teamSyncTimeStampForCompany = (
  params,
  header,
  customerId,
) =>
  externalDIRECTROUTINGBaseFetchAPI(`NumberAssignment/teamssynctimestampforcompany?companyId=${customerId}`, params, header, false)

  export const addTeamSyncTimeStampForCompany = (
  params,
  header,
  customerId,
  data={}
) =>
  externalDIRECTROUTINGBaseGetAPI(`NumberAssignment/addsynctimestamps?companyId=${customerId}`, data,header)


export const orderingLatestServiceDIRECTROUTINGNumberAssignmentGet = (
  params,
  customerId
) =>
  externalDIRECTROUTINGFetch(`NumberAssignment/teamsUsersupdate`, params, customerId)
export const orderingServiceDIRECTROUTINGNumberAssignmentDownload = (
  params,
  customerId
) =>
  externalDIRECTROUTINGDownloadExcel(
    `NumberAssignment/downloadteamsusers`,
    params,
    customerId
  )
export const orderingServiceDIRECTROUTINGNumberAssignmentStore = (
  data,
  customerId
) =>
  externalDIRECTROUTINGStore(
    `NumberAssignment?companyId=${customerId}`,
    data,
    customerId
  )

export const orderingServiceDIRECTROUTINGBulkNumberAssignmentStore = (
  customerId,
  data
) =>
  externalDIRECTROUTINGStore(
    `NumberAssignment/bulkNumberAssignments?companyId=${customerId}`,
    data
  )

export const orderingServiceDIRECTROUTINGBulkNumberAssignment = (
  customerId,
  file,
  email
) => {
  const formData = new FormData()
  formData.append('excelFile', file)
  formData.append('companyId', customerId)
  formData.append('email', email)
  return externalDIRECTROUTINGStore(
    `NumberAssignment/bulkNumberAssignments`,
    formData,
    customerId,
    email
  )
}

export const orderingServiceDIRECTROUTINGPost = (data, customerId) =>
  externalDIRECTROUTINGStore(`order`, data, customerId)

export const orderingServiceDIRECTROUTINGPostSubmit = (data, customerId) =>
  externalDIRECTROUTINGStore(`order/submit`, data, customerId)

export const orderingServiceDIRECTROUTINGPostTeamsBundle = (data, customerId) =>
  externalGENRICFUNCTIONALITYROUTINGStore(
    `TeamsBundleInfo`,
    data,
    customerId,
    PRODUCT_CODES.directRouting
  )
export const orderingServiceTeamsBundleInfoGet = (params, customerId) =>
  externalGENRICFUNCTIONALITYROUTINGFetch(
    `TeamsBundleInfo`,
    params,
    customerId,
    PRODUCT_CODES.directRouting
  )
export const orderingServiceTeamsBundleInfoAssignedGet = (params, customerId) =>
  externalGENRICFUNCTIONALITYROUTINGFetch(
    `TeamsBundleInfo/configured`,
    params,
    customerId,
    PRODUCT_CODES.directRouting
  )
export const orderingServiceTeamsBundle = (params, customerId) =>
  externalGENRICFUNCTIONALITYROUTINGFetch(
    `bundle/all`,
    params,
    customerId,
    PRODUCT_CODES.directRouting
  ) //moved

export const orderingServiceTFeatureChangeInfoGet = (params, customerId) =>
  externalDIRECTROUTINGFetch(`FeatureChangeInfo`, params, customerId)

export const orderingServiceDIRECTROUTINGNewNumRequest = (data, customerId) =>
  externalGENRICFUNCTIONALITYROUTINGStore(
    `NewNumberRequest`,
    customerId,
    PRODUCT_CODES.directRouting,
    data
  ) //moved
export const orderingServiceDIRECTROUTINGNewNumRequestGet = (
  orderId,
  customerId
) =>
  externalGENRICFUNCTIONALITYROUTINGFetch(
    `NewNumberRequest?OrderId=${orderId}`,
    '',
    customerId,
    PRODUCT_CODES.directRouting
  )

export const orderingServiceDIRECTROUTINGDetailsAllAPI = (params, customerId) =>
  externalDIRECTROUTINGFetch(`order/all`, params, customerId)

export const orderingServiceDIRECTROUTINGSuspendAPI = (body, customerId) =>
  externalDIRECTROUTINGUpdate(`order/suspend`, body, customerId)
export const orderingServiceDIRECTROUTINGReinStateAPI = (body, customerId) =>
  externalDIRECTROUTINGUpdate(`order/reinstate`, body, customerId)

export const orderingServiceRestrictionPlan = (params, customerId) =>
  externalDIRECTROUTINGFetch(`restrictionplan`, params, customerId)
export const orderingServiceRestrictionPlanById = (id, customerId) =>
  externalDIRECTROUTINGFetch(`restrictionplan/${id}`, customerId)

export const orderingServiceCompanyById = (params, customerId) =>
  externalGENRICFUNCTIONALITYROUTINGFetch(
    `company`,
    params,
    customerId,
    PRODUCT_CODES.directRouting
  )

export const orderingServiceConfigurationGet = (params, customerId) =>
  externalDIRECTROUTINGFetch(`Configuration`, params, customerId)
export const orderingServiceConfigurationPost = (params, customerId) =>
  externalDIRECTROUTINGStore(`Configuration`, params, customerId)

export const orderingServiceE911Validate = (body, customerId) =>
  externalGENRICFUNCTIONALITYROUTINGStore(
    `StaticE911/validate`,
    customerId,
    PRODUCT_CODES.directRouting,
    body
  )
export const orderingServiceE911Post = (body, customerId) =>
  externalGENRICFUNCTIONALITYROUTINGStore(
    `StaticE911`,
    customerId,
    PRODUCT_CODES.directRouting,
    body
  )
export const orderingServiceE911DynamicPost = (body, customerId) =>
  externalGENRICFUNCTIONALITYROUTINGStore(
    `DynamicE911/Dynamic`,
    customerId,
    PRODUCT_CODES.directRouting,
    body
  )

export const orderingServiceE911Delete = (number, customerId) =>
  externalGENRICFUNCTIONALITYROUTINGDestroy(`StaticE911/${number}`, customerId)

export const orderingServiceE911DynamicDelete = (number, customerId) =>
  externalGENRICFUNCTIONALITYROUTINGDestroy(
    `DynamicE911/Dynamic/${number}`,
    customerId,
    PRODUCT_CODES.directRouting
  )
export const orderingServiceE911Update = (body, customerId) =>
  externalGENRICFUNCTIONALITYROUTINGUpdate(
    `StaticE911`,
    body,
    customerId,
    PRODUCT_CODES.directRouting
  )

export const orderingServiceRemoveInfoDelete = (body, customerId) =>
  externalGENRICFUNCTIONALITYROUTINGStore(
    `RemoveNumber`,
    customerId,
    PRODUCT_CODES.directRouting,
    body
  )
export const orderingServiceRemoveInfoGet = (params, customerId) =>
  externalGENRICFUNCTIONALITYROUTINGFetch(
    `RemoveNumber?OrderId=${params}`,
    '',
    customerId,
    PRODUCT_CODES.directRouting
  )

export const orderingServicePortingGetAll = (params, customerId) =>
  externalDIRECTROUTINGFetch(`porting/all`, params, customerId)
export const orderingServicePortingByDate = (params, customerId) =>
  externalDIRECTROUTINGFetch(`porting/portdate?Date=${params}`, '', customerId)
export const orderingServicePortingWaitingDetails = (params, customerId) =>
  externalDIRECTROUTINGFetch(`porting/waiting`, params, customerId)
export const orderingServicePostPortingSubmitWaiting = (data, customerId) =>
  externalDIRECTROUTINGStore(`porting/submitwaiting`, data, customerId)
export const orderingServiceValidateForPorting = (data, customerId) =>
  externalDIRECTROUTINGStore(`porting/validateForPorting`, data, customerId)

// did
export const orderingServicePostPortingDid = (data, customerId) =>
  externalDIRECTROUTINGStore(`porting/did`, data, customerId)
export const orderingServiceCancelPortingDid = (data, customerId) =>
  externalDIRECTROUTINGStore(`porting/cancel/did`, data, customerId)
export const orderingServiceUploadFormsDid = (data, portingId, customerId) =>
  externalDIRECTROUTINGStore(
    `porting/uploadforms/did?DidPortingInfoId=${portingId}`,
    data,
    customerId
  )
export const orderingServicePortingDidGetOrderInfo = (params, customerId) =>
  externalDIRECTROUTINGFetch(`porting/did`, params, customerId)

export const orderingServiceViewPDFLoaDid = (data, customerId) =>
  externalDIRECTROUTINGDownload(
    `PdfView/Loa/Did?DidPortingInfoId=${data.DidPortingInfoId}`,
    {},
    customerId
  )
export const orderingServiceDownloadPDFDid = (params, customerId) =>
  externalDIRECTROUTINGDownload(
    `Download/Did?OrderId=${params.OrderId}&FileType=${params.FileType}`,
    '',
    customerId
  )
//toll-free
export const orderingServicePostPortingTollFree = (data, customerId) =>
  externalDIRECTROUTINGStore(`porting/TollFree`, data, customerId)
export const orderingServiceCancelPortingTollFree = (data, customerId) =>
  externalDIRECTROUTINGStore(`porting/cancel/TollFree`, data, customerId)
export const orderingServiceUploadFormsTollFree = (
  data,
  portingId,
  customerId
) =>
  externalDIRECTROUTINGStore(
    `porting/uploadforms/TollFree?TollFreePortingInfoId=${portingId}`,
    data,
    customerId
  )
export const orderingServicePortingTollFreeGetOrderInfo = (
  params,
  customerId
) => externalDIRECTROUTINGFetch(`porting/TollFree`, params, customerId)

export const orderingServiceViewPDFLoaTollFree = (data, customerId) =>
  externalDIRECTROUTINGDownload(
    `PdfView/Loa/TollFree?TollFreePortingInfoId=${data.TollFreePortingInfoId}`,
    {},
    customerId
  )
export const orderingServiceDownloadPDFTollFree = (params, customerId) =>
  externalDIRECTROUTINGDownload(
    `Download/TollFree?OrderId=${params.OrderId}&FileType=${params.FileType}`,
    '',
    customerId
  )

export const removeNumberAssignment = (customerId, data) =>
  externalDIRECTROUTINGStore(
    `NumberAssignment/removeNumberAssignment`,
    data,
    customerId
  )

export const DeactivateNumberFeature = (
  number,
  customerId
) =>
  externalGENRICFUNCTIONALITYROUTINGDestroy(
    `DidNumber/DeactiveNumberFeature?Number=${number}`,
    customerId,
    PRODUCT_CODES.directRouting
  )

// Document/documents/search?companyId=13b128e5-b2db-4213-a9a7-b3eaf7b9ab74'

export const getFilesByCompany = (
  params,
  header,
  customerId,
) =>
  externalCoreViewBaseWebPortalGetAPI(`Document/documents/search?companyId=${customerId}`, params, header)

export const uploadFileDoc = (
  params,
  header,
  customerId,
  data
) =>
  externalCoreViewBaseWebPortalGetAPI(`Document/documents?companyId=${customerId}`, data, header)

export const editFileDoc = (
  params,
  header,
  customerId,
  data
) =>
  externalDIRECTROUTINGBaseEditAPI(`Document/documents?companyId=${customerId}&fileId=${data.fileId}`, data, header)

export const deleteFileDoc = (
  params,
  header,
  customerId,
  data
) =>
  externalDIRECTROUTINGBaseDeleteAPI(`Document/documents/${data.fileId}?companyId=${customerId}`, params, header)
export const downloadFileDoc = (
  params,
  header,
  customerId,
  data
) =>
  externalCoreViewBaseWebPortalAPI(`Document/documents/${data.fileId}/download?companyId=${customerId}`, params, header, true)